export const state = {
  colorRoom1: '#FDFFDCFF',
  colorRoom2: '#663256FF',
  colorRoom3: '#ADBFD5FF',
  colorRoom4: '#C2164EFF',
  colorRoom5: '#62CA8AFF',
  colorRoom6: '#1F5497FF'
}

export const getters = {

}

export const mutations = {
  updateColorRoom1 (state, colorRoom1) {
    state.colorRoom1 = colorRoom1
  },
  updateColorRoom2 (state, colorRoom2) {
    state.colorRoom2 = colorRoom2
  },
  updateColorRoom3 (state, colorRoom3) {
    state.colorRoom3 = colorRoom3
  },
  updateColorRoom4 (state, colorRoom4) {
    state.colorRoom4 = colorRoom4
  },
  updateColorRoom5 (state, colorRoom5) {
    state.colorRoom5 = colorRoom5
  },
  updateColorRoom6 (state, colorRoom6) {
    state.colorRoom6 = colorRoom6
  }
}

export const actions = {
}

export default {
  state,
  getters,
  mutations,
  actions
}
